import { DiamondVoteResultItem } from "./DiamondVoteResultItem";

export default DiamondVoteResultItem;
